const acquisitionsMaxAgeDays = 90
const acquisitionsResultLimit = 100

export default {
  acquisitionsMaxAgeDays,
  acquisitionsResultLimit
}
